// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"pu_a bhe_rh bhe_tu","ForumSearch__img":"pu_b","ForumSearch__searchAdsAndShoppingAds":"pu_c","ForumSearch__results--empty":"pu_e"};